import {
  AuthRoute,
  Centered1000,
  Sidebar,
  SidebarWrapper,
  SidebarLogout,
  SidebarNaviItem,
  SidebarNexGroupNavItem,
} from 'arkulpa-fec';
import {HashRouter, Route, Redirect, Switch, Link} from 'react-router-dom';
import React, {Component} from 'react';
import jwt from 'jsonwebtoken';

import {ROLE_ADMIN} from './constants/userConstants';
import ChangePasswordPage from './containers/ChangePasswordPage';
import LoginPage from './containers/LoginPage';
import UserEdit from './containers/UserEdit';
import UserNew from './containers/UserNew';
import UsersPage from './containers/UsersPage';
import Devices from './components/Devices';
import config from './config.js';
import DeviceDetail from './components/DeviceDetail';
import DeviceNew from './components/DeviceNew';
import DeviceDebug from './components/DeviceDebug';
import DeviceMovement from './components/DeviceMovement';
import MovementSettings from './components/MovementSettings';

const logo = require('./img/logo.png');

function getUser() {
  let user;
  let token = config.getAuthToken();
  if (token) {
    token = token.replace('JWT ', '');
    user = jwt.decode(token);
    user.token = 'JWT ' + token;
  }
  return user;
}

export default class Navigation extends Component {
  _renderLoggedInContent = (user) => {
    return (
      <Centered1000>
        <Switch>
          <AuthRoute user={user} role={ROLE_ADMIN} exact path='/users' component={UsersPage} />
          <AuthRoute user={user} role={ROLE_ADMIN} exact path='/new/user' component={UserNew} />
          <AuthRoute user={user} role={ROLE_ADMIN} path='/user/:id' component={UserEdit} />
          <AuthRoute user={user} exact path='/devices' component={Devices} />
          <AuthRoute user={user} exact path='/new/device' component={DeviceNew} />
          <AuthRoute user={user} path='/device/:id' component={DeviceDetail} />
          <AuthRoute user={user} path='/device_debug/:id/:deviceId' component={DeviceDebug} />
          <AuthRoute user={user} exact path='/device_movement/:deviceId/:page' component={DeviceMovement} />
          <AuthRoute user={user} exact path='/movement_settings' component={MovementSettings} />
          <Redirect to='/devices' />
        </Switch>
      </Centered1000>
    );
  };
  _renderSidebarContent = ({role}) => {
    return (
      <SidebarWrapper>
        <SidebarNexGroupNavItem>
          <Link to={'/devices'}>Devices</Link>
        </SidebarNexGroupNavItem>
        <SidebarNexGroupNavItem>
          <Link to={'/movement_settings'}>Movement settings</Link>
        </SidebarNexGroupNavItem>
        {role === ROLE_ADMIN && (
          <SidebarNaviItem>
            <Link to={'/users'}>Users</Link>
          </SidebarNaviItem>
        )}

        <SidebarLogout
          onClick={() => {
            config.removeAuthToken();
            window.location.reload();
          }}>
          Abmelden
        </SidebarLogout>
      </SidebarWrapper>
    );
  };

  render() {
    let user = getUser();

    return (
      <div>
        <HashRouter>
          <Switch>
            <Route exact path='/reset-password/:token' component={ChangePasswordPage} />
            <Route
              exact
              path='/login'
              render={(props) =>
                user ? (
                  <Redirect to={{pathname: '/devices', state: {from: props.location}}} />
                ) : (
                  <LoginPage {...props} options={{logo}} rerender={() => this.setState({update: Date.now()})} />
                )
              }
            />

            <Sidebar logo={logo} sidebarContent={this._renderSidebarContent(user || {})}>
              {this._renderLoggedInContent(user)}
            </Sidebar>
          </Switch>
        </HashRouter>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Navigation.js